module.exports = __webpack_public_path__ + "img/battery.6782616a.svg";